module.exports = __webpack_public_path__ + "img/pick4.9f1bdb49.png";